module.exports = __webpack_public_path__ + "static/media/video-pleasant-ms.f05aaa4a.vtt";